import React, { Component } from 'react';
import { Modal, PanelGroup, Panel } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import filterValue from '../../../constants/variables';
import i18n from "i18next";

class RevisionModal extends Component {
  constructor(props) {
    super(props);

    this.handle = this.handle.bind(this);
    this.state = { showRevisionModal: props.showRevisionModal || false };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ showRevisionModal: nextProps.showRevisionModal });
  }

  mapForObject(obj, param) {
    const rows = [];
    let key = 0;

    for (const index in obj) {
      if (typeof param === 'function') rows.push(param(obj[index], index, key));
      else if (param === index) return obj[index];

      key++;
    }

    return rows;
  }

  handle() {
    this.setState({ showRevisionModal: !this.state.showRevisionModal });
    this.props.onChange();
  }


  render() {
    const { request } = this.props;
    let revisionsTotal = request.revisions ? request.revisions.length : 0

    return (
      <div style={{ display: 'inline' }}>
        <Modal show={this.state.showRevisionModal}>
          <Modal.Header
            closeButton
            onHide={this.handle}
          >
            <Modal.Title id="contained-modal-title">
              {i18n.t("revisions")}
              {' '}
                    /
              {' '}
              {i18n.t("revisionsTotal",{revisionsTotal})}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <PanelGroup>
              {
                                request.revisions && request.revisions.length > 0
                                  ? request.revisions.map((fields, key) => (
                                    <Panel key={key} collapsible header={fields.date} eventKey={key}>
                                      <table className="table table-hover table-bordered">
                                        <tbody>
                                          {
                                                        Object.keys(fields.fields).length > 0
                                                          ? this.mapForObject(fields.fields, (data, index, key2) => {
                                                            if (filterValue.travelExpenseVariables[index]) {
                                                              let nextData = [];
                                                              let incrementKey = key + 1;

                                                              while (incrementKey < request.revisions.length) {
                                                                nextData = this.mapForObject(request.revisions[incrementKey].fields, index);

                                                                if (typeof nextData !== 'object') {
                                                                  break;
                                                                }

                                                                incrementKey++;
                                                              }

                                                              if (typeof nextData === 'object') {
                                                                nextData = request[index];
                                                              }

                                                              if (index === 'travelStartDate' || index === 'travelEndDate') {
                                                                data = moment(data).format('DD/MM/Y');
                                                                nextData = moment(nextData).format('DD/MM/Y');
                                                              }


                                                              if (typeof nextData === 'boolean') {
                                                                nextData = nextData ? 'Var' : 'Yok';
                                                                data = data ? 'Var' : 'Yok';
                                                              }

                                                              let labelName = filterValue.travelExpenseVariables[index];

                                                              if (index === 'travelReasons') {
                                                                data = data.map(d => `${d.label} `);
                                                                nextData = nextData.map(d => `${d.label} `);
                                                              }

                                                              if (index === 'domestic') {
                                                                if (data && data.length > 0) {
                                                                  data = data.provinces ? data.provinces : [];
                                                                  data = data.map(d => `${d.label} `);
                                                                }else {
                                                                  data = [];
                                                                }
                                                                if (nextData && nextData.length > 0) {
                                                                  nextData = nextData.provinces ? nextData.provinces : [];
                                                                  nextData = nextData.map(d => `${d.label} `);
                                                                }else {
                                                                  nextData = [];
                                                                }
                                                                labelName = filterValue.travelExpenseVariables.provinces;
                                                              }

                                                              if (index === 'abroad') {
                                                                const fields = [];

                                                                for (const key in data) {
                                                                  while (incrementKey < data.length) {
                                                                    nextData = this.mapForObject(data[incrementKey], index);

                                                                    if (typeof nextData !== 'object') {
                                                                      break;
                                                                    }

                                                                    incrementKey++;
                                                                  }

                                                                  let beforeValue = data[key];
                                                                  let changedValue = nextData[key];

                                                                  if (typeof nextData === 'boolean') {
                                                                    changedValue = nextData[key] ? 'Var' : 'Yok';
                                                                    beforeValue = data[key] ? 'Var' : 'Yok';
                                                                  }

                                                                  if (key === 'workStartDate') {
                                                                    beforeValue = moment(data[key]).format('DD/MM/Y');
                                                                    changedValue = moment(nextData[key]).format('DD/MM/Y');
                                                                  }

                                                                  if (key === 'visa') {
                                                                    beforeValue = data[key] && data[key].label;
                                                                    changedValue = nextData[key] && nextData[key].label;
                                                                  }

                                                                  if (!_.isEqual(beforeValue, changedValue)
                                                                      && filterValue.travelExpenseVariables[key]) {
                                                                    fields.push(
                                                                      <tr key={key2}>
                                                                        <td>
                                                                          {filterValue.travelExpenseVariables[key]}
                                                                        </td>
                                                                        <td>
                                                                          <strong
                                                                            className="darkred"
                                                                          >
                                                                            {beforeValue}
                                                                          </strong>
                                                                          {' '}
                                                                                        /
                                                                          {' '}
                                                                          <strong
                                                                            className="green"
                                                                          >
                                                                            {changedValue}
                                                                          </strong>
                                                                        </td>
                                                                      </tr>
                                                                    );
                                                                  }
                                                                }

                                                                return (fields);
                                                              }

                                                              return (
                                                                <tr key={key2}>
                                                                  <td>
                                                                    {labelName}
                                                                  </td>
                                                                  <td>
                                                                    <strong
                                                                      className="darkred"
                                                                    >
                                                                      {data}
                                                                    </strong>
                                                                    {' '}
                                                                            /
                                                                    {' '}
                                                                    <strong
                                                                      className="green"
                                                                    >
                                                                      {nextData}
                                                                    </strong>
                                                                  </td>
                                                                </tr>

                                                              );
                                                            }

                                                            return null;
                                                          })
                                                          : null
                                                    }
                                        </tbody>
                                      </table>
                                    </Panel>

                                  ))
                                  : (
                                    <tr>
                                      <td>
                                        {i18n.t("dataHasNotBeenUpdated")}
                                      </td>
                                    </tr>
                                  )
                            }
            </PanelGroup>
          </Modal.Body>
          <Modal.Footer style={{ textAlign: 'left' }}>
            <button
              type="button"
              onClick={this.handle}
              className="btn btn-wd btn-default"
            >
              <span className="btn-label">
                <i
                  className="fa fa-arrow-left"
                />
              </span>
              {i18n.t("back")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default RevisionModal;



// WEBPACK FOOTER //
// ./src/components/travel-expense/revision/index.js